'use client';

import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '@/lib/auth/AuthProvider';
import { fetchCoinBalances } from './client';
import type { CoinBalanceEntry } from './models';

export const COIN_BALANCES_QK = 'coin-balances';

export function useCoinBalances() {
  const { isAuthenticated } = useAuthContext();

  return useQuery<CoinBalanceEntry[], Error>({
    queryKey: [COIN_BALANCES_QK],
    queryFn: () => {
      if (!isAuthenticated) throw new Error('Unauthorized');
      return fetchCoinBalances();
    },
    enabled: isAuthenticated,
    staleTime: Infinity, // Updates come via WebSocket
    refetchOnWindowFocus: false,
    refetchOnReconnect: true, // Refetch if connection was lost
    retry: false,
  });
}
